import React, { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { cardMarkup } from './gameHelpers';
import CardDeck from './CardDeck';

// The player's hand as a single deck: cycle with "Next Card"/swipe-left and
// commit with "Play Card"/swipe-right.
const CardStack = ({ blackCard, hand = [] }) => {
  const { game, playCard } = useContext(GlobalContext);

  if (hand.length === 0) {
    return (
      <div id="tm__cardStack" className="tm2">
        <h3>
          <i className="fas fa-circle-notch fa-spin"></i> Dealing your cards…
        </h3>
      </div>
    );
  }

  return (
    <div id="tm__cardStack" className="tm2">
      {blackCard && (
        <div
          className="blackcard--preview cardstack__black"
          dangerouslySetInnerHTML={cardMarkup(blackCard)}
        />
      )}

      <CardDeck
        items={hand}
        getText={(card) => card}
        onCommit={(card) => playCard(card)}
        commitLabel="Play Card"
        committingLabel="Playing…"
        countLabel={(n, total) => `Card ${n} of ${total}`}
      />

      {game?.error && (
        <p className="error" role="alert">
          {game.error}
        </p>
      )}
    </div>
  );
};

export default CardStack;
